import React from "react";
import { DatePicker } from "antd";
import { Label } from "../globals";

const DataPickerInputModal = (props) => {
  return (
    <>
      <Label
        className={props.classNameLabel}
        error={props.warning}
        required={props.required}
      >
        {props.text}
      </Label>
      <DatePicker
        disabledDate={props.disabledDate || false}
        showToday={false}
        type={props.type || "text"}
        className={`orange ${props.warning ? "error_border" : ""}`}
        style={{ width: "100%", ...props.style }}
        name={props.name || ""}
        placeholder={props.placeholder}
        value={props.value}
        onFocus={props.onFocus}
        onChange={props.onChange}
        disabled={props.disabled}
      />
      {props.warning && <div className="text-danger">{props.warning}</div>}
    </>
  );
};

DataPickerInputModal.defaultProps = {
  placeholder: "Choose",
};

export default DataPickerInputModal;
